import React from 'react';
import { usePlatformSettings } from '../../contexts/PlatformSettingsContext';

export const isLockedRate = (job) => !(Number(job?.pay_rate) > 0);

// Rate text for worker-facing views. Locked-rate shifts (posted with no rate) show the admin-chosen label or nothing.
export function usePayDisplay() {
  const { lockedRateDisplay } = usePlatformSettings();
  const hidden = lockedRateDisplay === 'hidden';
  return {
    hidden,
    rateText: (job) => (isLockedRate(job) ? (hidden ? null : 'Rate set by agency') : `$${job.pay_rate}/hr`),
    totalText: (job, hours) => {
      if (isLockedRate(job)) return hidden ? null : 'Set by agency';
      const total = Number(job.total_pay ?? (Number(job.pay_rate) || 0) * (Number(hours ?? job.duration_hours) || 0));
      return `$${total.toFixed(2)}`;
    },
  };
}

export function PayRate({ job, className = '', lockedClassName = '', testId = 'pay-rate-label' }) {
  const { rateText } = usePayDisplay();
  const text = rateText(job);
  if (text === null) return null;
  const locked = isLockedRate(job);
  return (
    <span className={`${className} ${locked ? lockedClassName : ''}`} data-testid={testId} data-locked-rate={locked ? 'true' : undefined}>
      {text}
    </span>
  );
}
